import { IdModel, UserShortInfo } from 'src/types';

export const fullName = ({ firstName, lastName }: { firstName: string; lastName: string }) =>
  `${firstName} ${lastName}`;

type SelectData = {
  value: IdModel;
  label: string;
};

export const userToSelectData = (user: UserShortInfo): SelectData => ({
  label: fullName(user),
  value: user.id,
});

export const usersToSelectData = (users: UserShortInfo[]): SelectData[] => users.map(userToSelectData);
